<template>
  <div class="eventos">
    <app-search-bar/>

    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :fechaInicioDesde="fechaInicioDesdeParam"
          :fechaInicioHasta="fechaInicioHastaParam"
          :cliente="cliente"
          :tipoEvento="tipoEvento"
          :sortByDescending="sortByDescending"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Listado de Eventos">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="eventos" 
              :fields="eventosFields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(fechaInicio)="data">
              {{ data.item.fechaInicio | fecha }}
            </template>
            <template v-slot:cell(fechaFin)="data">
              {{ data.item.fechaFin | fecha }}
            </template>
            <!-- <template slot="fechaFin" slot-scope="data">
              {{ data.item.fechaFin | fecha }}
            </template> -->
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item
                    v-if="accesoABM"
                    :disabled="data.item.sorteado" 
                    @click.stop="editarItem(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos del Evento</b-dropdown-item>

                <b-dropdown-item
                    v-if="accesoABM"
                    @click.stop="duplicarItem(data.item)">
                  <i class="fa fa-copy"></i>Duplicar Evento</b-dropdown-item>

                  <b-dropdown-item
                    v-if="accesoABM"
                    :disabled="data.item.sorteado || data.item.participantes != 0" 
                    @click.stop="borrarItem(data.item)">
                  <i class="fa fa-remove"></i>Borrar Evento</b-dropdown-item>

                <b-dropdown-item
                    v-if="data.item.tipoEventoId == 2"
                    @click.stop="consultarCodigosPromocion(data.item)">
                  <i class="fa fa-list"></i>Consultar Códigos de Promoción</b-dropdown-item>

                <b-dropdown-item
                    v-if="data.item.tipoEventoId == 2"
                    :disabled="(data.item.participantes != 0 & data.item.etapas == 0) ? true : false"
                    @click.stop="consultarEtapas(data.item)">
                  <i class="fa fa-list"></i>Consultar Etapas</b-dropdown-item>

                <b-dropdown-item @click.stop="consultarParticipantes(data.item)">
                  <i class="fa fa-users"></i>Consultar Participantes</b-dropdown-item>

                <b-dropdown-item @click.stop="consultarImagenes(data.item)">
                  <i class="fa fa-list"></i>Consultar Proof</b-dropdown-item>

                <b-dropdown-item 
                    v-if="!data.item.sorteado & data.item.sorteaGanadores" 
                    @click.stop="sortear(data.item)">
                  <i class="fa fa-trophy"></i>Sortear</b-dropdown-item>

                <b-dropdown-item 
                    v-if="data.item.sorteado" 
                    @click.stop="consultarSorteo(data.item)">
                  <i class="fa fa-trophy"></i>Consultar Resultados del Sorteo</b-dropdown-item>

                <b-dropdown-item 
                    v-if="data.item.importaGanadores || data.item.tipoEventoId == 3" 
                    @click.stop="consultarGanadores(data.item)">
                  <i class="fa fa-trophy"></i>Consultar Resultados del Sorteo</b-dropdown-item>

                <b-dropdown-item 
                    v-if="data.item.tipoEventoId == 2"
                    @click.stop="descargarImagenesParticipantes(data.item)">
                  <i class="fa fa-image"></i>Descargar Imágenes de Participantes
                </b-dropdown-item>
                
                <b-dropdown-item
                  @click.stop="consultarStatus(data.item)">
                  <i class="fa fa-bar-chart"></i>Consultar Status
                </b-dropdown-item>

                <b-dropdown-item 
                  v-if="data.item.id == 145" 
                  @click.stop="exportRptGenExpertos(data.item)">
                  <i class="fa fa-file-excel-o"></i>Reporte GenExpertos
                </b-dropdown-item>
              </b-dropdown>
            </template>            
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn"
        v-if="accesoABM">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="agregar">
            <i class="fa fa-plus"></i>Nuevo Evento</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-modal ref="sorteoModal" 
        title="Sorteo del Evento"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-sorteo
        :eventoId="eventoId"
        :sorteoGlobalId="0"
        @close="closeSorteo">
      </app-sorteo>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Sorteo from '../sorteos/SorteoABM.vue';
import Filtro from './listFiltro.vue';
import SearchBar from  '../searchList/SearchBar.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import exportXLSRptEventos from '../../mixins/export_xls_rpt_eventos';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'eventos/getField',
  mutationType: 'eventos/updateField',
});

export default {
  name: 'Eventos',
  components: {
    appFiltro: Filtro,
    appSorteo: Sorteo,
    appSearchBar: SearchBar,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
    exportXLSRptEventos
  ],
  data: () => {
    return {
      eventosFields: [
        { 
          key: 'id',
          label: 'Nro.Evento'
        },
        { key: 'cliente' },
        { key: 'nombre' },
        { 
          key: 'tipoEvento',
          label: 'Tipo de Evento'
        },
        { 
          key: 'participantes',
          class: 'text-right'
        },
        { key: 'fechaInicio'},
        { key: 'fechaFin'},
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
      eventoId: 0,
      accesoABM: false
    }
  },
  computed: {
    ...mapFields([
      'eventos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaInicioDesde',
      'fechaInicioHasta',
      'cliente',
      'tipoEvento',
      'sortByDescending'
    ]),
    fechaInicioDesdeParam() {
      return moment(this.fechaInicioDesde).format('YYYY-MM-DD');
    },
    fechaInicioHastaParam() {
      return moment(this.fechaInicioHasta).format('YYYY-MM-DD');
    }
  },
  created() {
    if ((/true/i).test(this.$store.getters['user/admin'])) {
      this.accesoABM = true;
    }

    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.fechaInicioDesde = moment(filtro.fechaInicioDesde).format('YYYY-MM-DD'),
      this.fechaInicioHasta = moment(filtro.fechaInicioHasta).format('YYYY-MM-DD'),
      this.cliente = filtro.cliente;
      this.tipoEvento = filtro.tipoEvento;
      this.sortByDescending = filtro.sortByDescending;
      this.paginaActual = 1;
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('eventos/getEventos')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    agregar () {
      this.$router.push({ name: 'EventoAdd' });
    },
    editarItem (item) {
      this.$router.push({ name: 'EventoEdit', 
                          params: { id: item.id }});
    },
    duplicarItem (item) {
      this.$router.push({ name: 'EventoDuplicar', 
                          params: { id: item.id }});
    },
    borrarItem (item) {
      this.showModalConfirm('¿Desea borrar el evento seleccionado?', 
            this.borrarEvento.bind(this, item.id), 'Si', null, 'No')
    },
    borrarEvento(eventoId) {
      this.showSpinner();
      this.$store.dispatch('eventos/delete', eventoId)
        .then(() => {
          this.showModalMsj('El evento seleccionado se borró con éxito.', null, null, 'light')
          this.getItems();
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    consultar (item) {
      this.$router.push({ name: 'EventoDatos', 
                          params: { id: item.id }});
    },
    consultarStatus(item) {
      this.$router.push({ name: 'EventoStatus', 
                          params: { id: item.id }});
    },
    consultarCodigosPromocion (item) {
      this.$router.push({ name: 'EventoCodigosPromocion', 
                          params: { id: item.id }});
    },
    consultarEtapas (item) {
      this.$router.push({ name: 'EventosEtapas', 
                          params: { eventoId: item.id }});
    },
    consultarParticipantes (item) {
      this.$router.push({ name: 'Participantes', 
                          params: { eventoId: item.id }});
    },
    consultarImagenes (item) {
      this.$router.push({ name: 'EventoProof', 
                          params: { id: item.id }});
    },
    sortear (item) {
      /* Validamos si el cliente es DTV, mostramos el form con las opciones del sorteo */
      let clienteId = this.$store.getters['user/clienteId'];

      if (clienteId == 1) {
        /* Mostramos las opciones del sorteo */
        this.eventoId = item.id;
        this.$refs.sorteoModal.show();
      } else {
        this.showModalConfirm('¿Desea realizar el sorteo del evento seleccionado?', 
              this.sortearEvento.bind(this, item), 'Si', 
              null, 'No')
      }
    },
    sortearEvento(item) {
        /* Sorteamos el evento */
        let params = {
          eventoId: item.id,
          sorteoGlobalId: 0,
          soloClientes: false,
          dobleChanceClientes: false
        }

        this.showSpinner();
        this.$store.dispatch('sorteo/sortear', params)
          .then(()  => this.showModalMsj('El sorteo se completó éxito.', 
            this.consultarSorteo.bind(this, item), this.consultarSorteo.bind(this, item), 'light'))
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner())
    },
    closeSorteo(sorteado) {
      this.$refs.sorteoModal.hide();
      if (sorteado) {
        this.$router.push({ name: 'ResultadosSorteo', 
                            params: { eventoId: this.eventoId }});
      }
    },
    consultarSorteo (item) {
      this.$router.push({ name: 'ResultadosSorteo', 
                          params: { eventoId: item.id }});
    },
    consultarGanadores (item) {
      this.$router.push({ name: 'Ganadores', 
                          params: { eventoId: item.id }});
    },
    exportRptGenExpertos(item) {
      this.showSpinner();
      this.$store.dispatch('eventoDatos/getRptGenExpertos', item.id)
        .then(() => {
          let exportar = false;
          let reporte = this.$store.getters['eventoDatos/rptGenExpertos'];

          if (reporte) {
            exportar = true;
          }

          if (exportar) {
            this.exportXLSRptGenExpertos(reporte);
          } else {
            this.showErrorMsj('Se produjo un error al recuperar la información del evento.');
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    descargarImagenesParticipantes(item) {
      this.showSpinner();
      this.$store.dispatch('eventos/descargarImagenesParticipantes', item.id)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    }
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
  .eventos .registro table td[aria-colindex="1"] {
    width: 10%;
  }
  .eventos .registro table td[aria-colindex="2"] {
    width: 15%;
  }
  .eventos .registro table td[aria-colindex="3"] {
    width: Calc(30% - 30px);
  }
  .eventos .registro table td[aria-colindex="4"] {
    width: 15%;
  }
  .eventos .registro table td[aria-colindex="5"] {
    width: 10%;
  }
  .eventos .registro table td[aria-colindex="6"],
  .eventos .registro table td[aria-colindex="7"] {
    width: 10%;
  }
  .eventos .registro table td[aria-colindex="8"] {
    width: 30px;
  }
</style>
